<template>
    <el-dialog
        :title="formDialog.title"
        :visible.sync="formDialog.visible"
        direction="rtl"
        :before-close="closeDialog"
        width="30%"
        append-to-body
    >
        <div class="dialog-form">
            <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="120px"
                label-position="left"
            >
                <el-form-item label="账号名称" prop="title">
                    <el-input v-model="ruleForm.title"></el-input>
                </el-form-item>
                <el-form-item label="区域" prop="sort">
                    <el-select v-model="ruleForm.city_id" clearable placeholder="区域">
                        <el-option
                            v-for="(item, index) in region"
                            :key="index"
                            :label="item.title"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="排序" prop="sort">
                    <el-input v-model="ruleForm.sort"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="saveDialog('ruleForm')">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    </el-dialog>
</template>

<script>
import dictionary from '@/utils/dictionary.js';
let formFields = {
    id: 0,
    source_id: '',
    title: '',
    sort: 0,
    city_id: ''
};

export default {
    props: {
        parent: {}
    },
    data() {
        let region = dictionary.getRegion();

        return {
            formDialog: {
                title: '',
                visible: false,
                method: 'create'
            },
            region: region,
            ruleForm: Object.assign({}, formFields),
            rules: {
                title: [{ required: true, message: '请输入账号名称', trigger: 'blur' }]
            }
        };
    },
    methods: {
        // 显示添加、编辑渠道视图
        showDialog(row, type = 'create') {
            // let that = this;
            this.ruleForm = Object.assign({}, formFields);
            this.formDialog.visible = true;
            // 添加账号
            if (type == 'create') {
                this.formDialog.title = '添加账号';
                this.formDialog.action = '/api/dictionary.account/create';
                this.ruleForm.source_id = row.source_id;
                return false;
            }

            // 编辑渠道
            this.formDialog.title = '编辑账号';
            this.formDialog.action = '/api/dictionary.account/save';

            if (row.city_id > 0) {
                row.city_id = row.city_id + '';
            } else {
                row.city_id = '';
            }
            this.ruleForm = Object.assign({}, row);
        },

        // 保存
        saveDialog(formName) {
            let that = this;
            let query = this.ruleForm;
            let dialog = this.formDialog;
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.$post(dialog.action, query).then(function(response) {
                        if (response.code == '200') {
                            that.parent.getTableData();
                            that.closeDialog();
                            that.$message.success(response.msg);
                        } else {
                            that.$message.error(response.msg);
                        }
                    });
                } else {
                    this.$message('请填写完整并检查您的填写信息');
                }
            });
        },
        // 清空内容
        closeDialog() {
            this.formDialog.visible = false;
            this.treeChecked = [];
            this.$refs['ruleForm'].resetFields();
            // 初始化数据
            this.ruleForm ={
                id: 0,
                source_id: '',
                title: '',
                sort: 0,
                city_id: ''
            }
        }
    }
};
</script>

<style lang="less">
.dialog-form {
    padding: 20px;
}
.user-edit .el-dialog__body {
    overflow: auto;
}
/* input Number类型不要上下箭头 */

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    appearance: none;
    margin: 0;
}
</style>
